import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, inject } from '@angular/core';
import { FormControl, FormGroup, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {Adresse, AdresseInterface} from '../../../class/api/Adresse';
import {HydraService} from '../../../core/services/hydra.service';
import {api} from '../../../api/api-dictionnary';
import {HydraCollection} from '../../../class/generic/hydra-collection';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import {Country} from '../../../class/api/Country';

import { ControlsMessagesComponent } from '../controls-messages/controls-messages.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';

@Component({
    selector: 'app-geocoder',
    template: `
        @if (formGroup !== null) {
          <div>
            <form class="form-horizontal" [formGroup]="formGroup">
              <div class="row">
                @if (displayNumEtRue) {
                  <div class="col">
                    <fieldset class="form-group {{!numEtVoieCtrl.valid ? 'form-error' : ''}}"
                      [hidden]="disappear === 'numEtVoie'">
                      <label for="numEtVoie_{{ idComponent }}">{{ 'general.numeroRue' | translate }} <span
                      class="star">*</span></label>
                      <input class="form-control" id="numEtVoie_{{ idComponent }}" [formControl]="numEtVoieCtrl"/>
                      <app-controls-messages [control]="numEtVoieCtrl"></app-controls-messages>
                    </fieldset>
                  </div>
                }
              </div>
              <div class="row">
                <div class="col">
                  <fieldset class="form-group {{!codePostalCtrl.valid ? 'form-error' : ''}}">
                    <label for="codePostal_{{ idComponent }}">{{ 'general.codePostal' | translate }} <span
                    class="star">*</span></label>
                    <input class="form-control" id="codePostal_{{ idComponent }}" type="text" required
                      [formControl]="codePostalCtrl"/>
                      <app-controls-messages [control]="codePostalCtrl"></app-controls-messages>
                    </fieldset>
                  </div>
                  <div class="col">
                    <fieldset class="form-group {{!villeCtrl.valid ? 'form-error' : ''}}">
                      <label for="ville_{{ idComponent }}">{{ 'general.ville' | translate }} <span
                      class="star">*</span></label>
                      <input class="form-control" id="ville_{{ idComponent }}" type="text" required
                        [formControl]="villeCtrl"/>
                        <app-controls-messages [control]="villeCtrl"></app-controls-messages>
                      </fieldset>
                    </div>
                  </div>
                  <div class="row">
                    @if (cedex) {
                      <div class="col">
                        <fieldset class="form-group {{!cedexCtrl.valid ? 'form-error' : ''}}">
                          <label for="cedex_{{ idComponent }}">{{ 'general.cedex' | translate }}</label>
                          <input class="form-control" id="cedex_{{ idComponent }}" type="text"
                            [formControl]="cedexCtrl"/>
                            <app-controls-messages [control]="cedexCtrl"></app-controls-messages>
                          </fieldset>
                        </div>
                      }
                      <div class="col">
                        <fieldset class="form-group  {{!paysCtrl.valid ? 'form-error' : ''}}">
                          <label for="country_{{ idComponent }}">{{ 'general.pays' | translate }} <span
                          class="star">*</span></label>
                          <mat-select class="form-control" id="country_{{ idComponent }}" [formControl]="paysCtrl"
                            [compareWith]="compareById" required>
                            @for (country of countries; track country) {
                              <mat-option [value]="country['@id']">
                                {{ country?.label }}
                              </mat-option>
                            }
                          </mat-select>
                          <app-controls-messages [control]="paysCtrl"></app-controls-messages>
                        </fieldset>
                      </div>
                    </div>
                  </form>
                </div>
              }
        `,
    imports: [FormsModule, ReactiveFormsModule, ControlsMessagesComponent, MatSelect, MatOption, TranslateModule]
})
export class GeocoderComponent implements OnInit, AfterViewInit, OnChanges {
    private hydraService = inject(HydraService);
    translate = inject(TranslateService);
    private detectorRef = inject(ChangeDetectorRef);

    public idComponent = '';

    @Input() public displayNumEtRue = true;


    public _adresse: AdresseInterface = null;
    public _disabled = false;
    @Input() private instance = 'Default';

    @Input() set adresse(value: AdresseInterface) {
        console.log('set adresse >> '+this.instance, value);
        if(value){
           if(this._adresse == null || this._adresse.id == null || (value['id'] != undefined && value.id != this._adresse.id)){
               this.setAdresse(value);
           }
        }
    }


    @Input()
    public restrictCountryValue?: string = '';
    @Output() place: EventEmitter<AdresseInterface> = new EventEmitter();

    @Input() set disabled(value) {
        this._disabled = value;
        this.updateDisabled();
    }

    @Input() cedex = true;
    @Input() disappear: string = null;
    @Input('defaultData')
    @Input() disablePays = false;
    private defaultData: GeocoderComponent;

    public formGroup: FormGroup = null;

    public numEtVoieCtrl: FormControl = new FormControl<string>('', [
        this.displayNumEtRue ? Validators.required : null,
         Validators.maxLength(150)
    ]);
    public codePostalCtrl: FormControl = new FormControl<string>('', [
        Validators.required,
        Validators.maxLength(12)
    ]);
    public villeCtrl: FormControl = new FormControl<string>('', [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(50)
    ]);
    public paysCtrl: FormControl = new FormControl<string>({value:'', disabled:this.restrictCountryValue === 'FR'}, [Validators.required]);
    public cedexCtrl: FormControl = new FormControl<string>('');

    constructor() {
        this.idComponent = this.guidGenerator();
        this.formGroup = new UntypedFormGroup({
            numEtVoie: this.numEtVoieCtrl,
            codePostal: this.codePostalCtrl,
            ville: this.villeCtrl,
            pays: this.paysCtrl,
            cedex: this.cedexCtrl,
        });
        this.idComponent = this.guidGenerator();
    }

    isValid() {
        return this.formGroup.valid;
    }

    guidGenerator() {
        const S4 = function() {
            return (((1 + Math.random()) * 0x10000) | 0)
                .toString(16)
                .substring(1);
        };
        return (
            S4() +
            S4() +
            '-' +
            S4() +
            '-' +
            S4() +
            '-' +
            S4() +
            '-' +
            S4() +
            S4() +
            S4()
        );
    }


    public updateDisabled() {
        if (this._disabled) {
            this.numEtVoieCtrl.disable();
            this.codePostalCtrl.disable();
            this.villeCtrl.disable();
            this.paysCtrl.disable();
            this.cedexCtrl.disable();
        } else {
            this.numEtVoieCtrl.enable();
            this.codePostalCtrl.enable();
            this.villeCtrl.enable();
            this.paysCtrl.enable();
            this.cedexCtrl.enable();
        }
    }

    public caMeCasseVraimentLesCouillesCetteHistoireDadresse() {
        if (this._adresse != null) {
            this.cedexCtrl.setValue(this._adresse.cedex);
            this.cedexCtrl.markAsTouched();

            if (
                this.defaultData &&
                this._adresse.numEtVoie == null
            ) {
                this._adresse.numEtVoie = this.defaultData._adresse.numEtVoie;
            }
            this.numEtVoieCtrl.setValue(this._adresse.numEtVoie);
            this.numEtVoieCtrl.markAsTouched();
            this.codePostalCtrl.setValue(this._adresse.codePostal);
            this.codePostalCtrl.markAsTouched();
            this.villeCtrl.setValue(this._adresse.ville);
            this.villeCtrl.markAsTouched();
            if (
                this._adresse.pays != null &&
                this._adresse.pays['@id'] != null
            ) {
                this.paysCtrl.setValue(this._adresse.pays['@id']);
                this.paysCtrl.markAsTouched();
            }
            if (
                typeof this._adresse.pays == 'string' &&
                this._adresse.pays.length
            ) {
                this.paysCtrl.setValue(this._adresse.pays);
                this.paysCtrl.markAsTouched();
            }
        }
        if (this._disabled) {
            this.numEtVoieCtrl.disable();
            this.codePostalCtrl.disable();
            this.villeCtrl.disable();
            this.paysCtrl.disable();
            this.cedexCtrl.disable();
        }

    }


    countries = [];

    ngAfterViewInit() {
        this.caMeCasseVraimentLesCouillesCetteHistoireDadresse();
        this.hydraService
            .getList(api.countries, true)
            .subscribe((res: HydraCollection) => {
                if (this.restrictCountryValue === 'FR') {
                    res.getMember().map((item: Country) => {
                        if (item.code == 'FR') {
                            this.countries = [item];
                            this.paysCtrl.setValue(item['@id']);
                            this.paysCtrl.markAsTouched();
                        }
                    });
                } else {
                    if (this.restrictCountryValue === 'HORS_FR') {
                        const pays = res.getMember();
                        this.countries = pays.filter(p => p.code !== 'FR');
                    } else {
                        this.countries = res.getMember();
                    }
                }
            });

        if (this.disablePays) {
            this.paysCtrl.disable();
        } else {
            this.paysCtrl.enable();
        }

        this.detectorRef.detectChanges();
    }

    public compareById(itemOne, itemTwo) {
        return itemOne && itemTwo && itemOne == itemTwo;
    }

    public _timeout: any = null;

    public setAdresse(adresse: AdresseInterface
    ) {
        this._adresse = adresse;
        this.caMeCasseVraimentLesCouillesCetteHistoireDadresse();
    }

    ngOnInit() {
        //Si la valeur du form est valid alors on déclanche l'émetteur a chaque changement
        this.formGroup.valueChanges.subscribe(res => {
            if (this._timeout != null) {
                window.clearTimeout(this._timeout);
            }
            this._timeout = window.setTimeout(() => {
                const oldAdresse = this._adresse as Adresse;
                const newAdresse = this.formGroup.getRawValue() as Adresse;

                const oldAdresseComplete:
                    | string
                    | boolean = this.getFullAdresse(oldAdresse);
                const newAdresseComplete:
                    | string
                    | boolean = this.getFullAdresse(newAdresse);

                if (
                    (typeof oldAdresseComplete === 'string' &&
                        typeof newAdresseComplete === 'string') ||
                    (oldAdresseComplete === false && newAdresseComplete)
                ) {
                    if (oldAdresseComplete != newAdresseComplete) {
                        this._adresse = {
                            ...this._adresse,
                            ...newAdresse,
                        } as Adresse;
                        this._adresse.adresseComplete = newAdresseComplete as any;
                        this.place.emit(this._adresse);
                    }
                }
            }, 500);
        });
    }

    public getFullAdresse(data: Adresse = null): string | boolean {
        let numEtVoie = '';
            let codePostal = '';
            let ville = '';
            let cedex = '';
            let pays = '';
        if (data) {
            if (data.numEtVoie != null) {numEtVoie = data.numEtVoie;}
            if (data.codePostal != null) {codePostal = data.codePostal;}
            if (data.ville != null) {ville = data.ville;}
            if (data.cedex != null) {cedex = data.cedex;}
            if (
                data.pays &&
                typeof data.pays === 'string' &&
                data.pays.length
            ) {
                if (this.countries.length) {
                    const itemSelected = this.countries.find(
                        item => item['@id'] === data.pays
                    );
                    if (
                        itemSelected &&
                        typeof itemSelected === 'object' &&
                        itemSelected.hasOwnProperty('label')
                    ) {
                        pays = itemSelected['label'];
                    }
                }
            }
            if (
                data.pays &&
                typeof data.pays === 'object' &&
                data.pays['label']
            ) {
                pays = data.pays.label;
            }
        }
        return !data ? false : `${numEtVoie} ${cedex} ${codePostal} ${ville} ${pays}`;
    }

    ngOnChanges(changes: SimpleChanges
    ) {
    }
}
